import { useFormikContext } from 'formik';

import Switch from 'components/shared/Switch/Switch';
import Divider from 'components/shared/Divider/Divider';
import Textarea from 'components/shared/Textarea/Textarea';
import Allowed from 'components/shared/Permissions/Allowed';
import SectionList from 'components/practice/UserPreferences/components/SectionList';

import PaymentLinkShare from './components/PaymentLinkShare';
import { DESCRIPTION_MAX, getPaymentLinkSettings } from './lib/helpers';

const PaymentLinkSettings = ({ practice }) => {
  const { setFieldValue, values } = useFormikContext();
  const settings = getPaymentLinkSettings(values?.displaySettings);

  const updateSettings = (patch) =>
    setFieldValue('displaySettings', {
      ...values?.displaySettings,
      standalone_payment: { ...settings, ...patch }
    });

  return (
    <Allowed requiredModules="medipay.payment_suite.credit_card">
      <Divider />
      <SectionList
        title="Payment link"
        description="A public link anyone can use to pay your practice by card. When the name and email match one of your patients, the payment is assigned to them automatically. Otherwise it lands in Payments for you to assign.">
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-2">
            <Switch
              checked={settings.enabled}
              onChange={(checked) => updateSettings({ enabled: checked })}
              id="payment-link-switch"
            />
            <label htmlFor="payment-link-switch" className="text-sm font-400 text-neutral-900">
              Accept payments through the payment link
            </label>
          </div>

          {settings.enabled && (
            <>
              <Textarea
                id="payment-link-description"
                name="paymentLinkDescription"
                label="Message shown to patients"
                placeholder="e.g. Use this link to pay your balance. Include your invoice number if you have one."
                value={settings.description}
                maxLength={DESCRIPTION_MAX}
                onChange={(event) => updateSettings({ description: event.target.value })}
              />
              <PaymentLinkShare practice={practice} />
            </>
          )}
        </div>
      </SectionList>
    </Allowed>
  );
};

export default PaymentLinkSettings;
